module.exports = __webpack_public_path__ + "img/htree_phone.d38bdd2f.png";